module.exports = __webpack_public_path__ + "img/guo.7f256a26.png";